import { createTheme, ThemeProvider } from "@mui/material";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./store";

import "./index.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffcc01",
    },
    secondary: {
      main: "#000000",
    },
  },
  shape: {
    borderRadius: 20,
  },
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
